import { createRouter, createWebHashHistory } from 'vue-router';
import BaseLayout from '@/components/BaseLayout.vue';
import News from '@/views/NewsView.vue';
import ProjectsList from '@/views/ProjectsListView.vue';
import ProjectDetail from '@/views/ProjectDetailView.vue';
import MembersList from '@/views/MemberView.vue';
import TechnicalCommittee from '@/views/TechnicalCommitteeView.vue';
import AboutView from '@/views/AboutView.vue';
import BuildingView from '@/views/BuildingView.vue';
import HezuopinpaiView from '@/views/Hezuopinpai.vue';

import LoginView from '@/views/admin/LoginView.vue';
import AdminLayout from '@/components/AdminLayout.vue';
import Dashboard from '@/views/admin/DashboardView.vue';
import ManageNews from '@/views/admin/ManageNewsView.vue';
import ManageProjects from '@/views/admin/ManageProjectsView.vue';
import ManageMembers from '@/views/admin/ManageMembersView.vue';
import ManageCommittees from '@/views/admin/ManageTechnicalCommittee.vue';

const routes = [
  {
    path: '/',
    component: BaseLayout,
    children: [
      {
        path: '',
        name: 'home',
        component: News,
        meta: { title: '首页 - 小易装修之家' }
      },
      {
        path: 'project-list.html',
        name: 'project-list',
        component: ProjectsList,
        meta: { title: '项目一览 - 小易装修之家' }
      },
      {
        path: '/project/:id.html',
        name: 'ProjectDetail',
        component: ProjectDetail,
        meta: { title: '项目详情 - 小易装修之家' }
      },
      {
        path: 'member-list.html',
        name: 'members',
        component: MembersList,
        meta: { title: '成员列表 - 小易装修之家' }
      },
      {
        path: 'committee-list.html',
        name: 'committee',
        component: TechnicalCommittee,
        meta: { title: '用户端 - 小易装修之家' }
      },
      {
        path: 'about.html',
        name: 'about',
        component: AboutView,
        meta: { title: '设计师' }
      },
      {
        path: 'building.html',
        name: 'building',
        component: BuildingView,
        meta: { title: '建材选购' }
      },
      {
        path: 'hezuopinpai.html',
        name: 'hezuopinpai',
        component: HezuopinpaiView,
        meta: { title: '合作品牌 - 小易装修之家' }
      },
      {
        path: '/:pathMatch(.*)*',
        redirect: '/'
      }
    ]
  },
  {
    path: '/admin',
    component: AdminLayout,
    children: [
      {
        path: '',
        name: 'index',
        component: Dashboard,
        meta: { title: '仪表盘 - 小易装修之家' }
      },
      {
        path: 'dashboard.html',
        name: 'admin-dashboard',
        component: Dashboard,
        meta: { title: '仪表盘 - 小易装修之家' }
      },
      {
        path: 'manage-news.html',
        name: 'manage-news',
        component: ManageNews,
        meta: { title: '新闻动态管理 - 小易装修之家' }
      },
      {
        path: 'manage-projects.html',
        name: 'manage-projects',
        component: ManageProjects,
        meta: { title: '项目管理 - 小易装修之家' }
      },
      {
        path: 'manage-members.html',
        name: 'manage-members',
        component: ManageMembers,
        meta: { title: '成员管理 - 小易装修之家' }
      },
      {
        path: 'manage-committees.html',
        name: 'manage-committees',
        component: ManageCommittees,
        meta: { title: '技术委员管理 - 小易装修之家' }
      },
      {
        path: 'login.html',
        name: 'admin-login',
        component: LoginView,
        meta: { title: '登录 - 小易装修之家' }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: to => {
      // 处理带.html后缀的路由
      if (to.path.endsWith('.html') && !to.path.startsWith('/admin')) {
        return { path: to.path.replace(/\.html$/, '') }
      }
      return '/'
    }
  }
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL), // 确保使用正确的base路径
  routes,
  // 新增滚动行为配置
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { top: 0 }
  }
});

router.beforeEach((to, from, next) => {
  const isLoggedIn = !!localStorage.getItem('token');
  document.title = to.meta.title || '小易装修之家';
  
  if (to.path.startsWith('/admin')) {
    if (!isLoggedIn) {
      if (to.name === 'admin-login') {
        next();
      } else {
        next({ name: 'admin-login' });
      }
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
export { routes };
